/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Readiness_Rir_IncreaseInputs */

const en_us2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Leave 1 more rep in reserve`);
	return /** @type {LocalizedString} */ (`Leave ${i?.count} more reps in reserve`)
	
};

const pt_br2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Deixe 1 repetição a mais na reserva`);
	return /** @type {LocalizedString} */ (`Deixe ${i?.count} repetições a mais na reserva`)
	
};

const es_419_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Deja 1 repetición más en reserva`);
	return /** @type {LocalizedString} */ (`Deja ${i?.count} repeticiones más en reserva`)
	
};

const pt_pt2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Deixa mais 1 repetição em reserva`);
	return /** @type {LocalizedString} */ (`Deixa mais ${i?.count} repetições em reserva`)
	
};

const fr_fr2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Garde 1 répétition de plus en réserve`);
	return /** @type {LocalizedString} */ (`Garde ${i?.count} répétitions de plus en réserve`)
	
};

const de_de2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Lass 1 Wiederholung mehr in Reserve`);
	return /** @type {LocalizedString} */ (`Lass ${i?.count} Wiederholungen mehr in Reserve`)
	
};

const it_it2_workout_readiness_rir_increase = /** @type {(inputs: Workout_Readiness_Rir_IncreaseInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Tieni 1 ripetizione in più in riserva`);
	return /** @type {LocalizedString} */ (`Tieni ${i?.count} ripetizioni in più in riserva`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Leave 1 more rep in reserve" |
* | * | "Leave {count} more reps in reserve" |
*
* @param {Workout_Readiness_Rir_IncreaseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_rir_increase = /** @type {((inputs: Workout_Readiness_Rir_IncreaseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_Rir_IncreaseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_rir_increase(inputs)
	if (locale === "es-419") return es_419_workout_readiness_rir_increase(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_rir_increase(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_rir_increase(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_rir_increase(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_rir_increase(inputs)
	return en_us2_workout_readiness_rir_increase(inputs)
});
export { workout_readiness_rir_increase as "workout.readiness_rir_increase" }